import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  useDeleteOtherDocumentMutation,
  useUpdateOtherDocumentMutation,
} from "@src/__generated__/graphql";
import { ModalConfirm } from "@src/components/ui-kit";
import { DataTableActionButton } from "@src/components/ui-kit/DataTable/DataTableActionButton";
import { onError } from "@src/utils/apollo";
import { can, withCan } from "@src/utils/components/permissions";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import type React from "react";
import { type FunctionComponent, useContext, useEffect, useState } from "react";
import { ModalOtherDocumentForm } from "../../form/otherDocument/ModalOtherDocumentForm";
import {
  FormOtherDocumentCtx,
  StoreOtherDocumentForm,
} from "../../form/otherDocument/StoreOtherDocumentForm";
import type { OtherDocumentModel } from "../../models";
import { DocumentsCtx } from "../../StoreDocuments";

export const PopoverRowActions: FunctionComponent<
  React.PropsWithChildren<{ doc: OtherDocumentModel }>
> = withCan(
  { do: ["otherDocument_delete", "otherDocument_update"] },
  observer(function PopoverRowActions({ doc }) {
    const pageStore = useContext(DocumentsCtx);

    const [store] = useState(() => {
      const store = StoreOtherDocumentForm.create();
      return store;
    });

    const editModal = useDisclosure();
    const delModal = useDisclosure();

    const [update, updateReq] = useUpdateOtherDocumentMutation({
      onCompleted() {
        pageStore.refetchOtherDocs?.();
        editModal.onClose();
      },
      ...onError(),
    });

    const [del] = useDeleteOtherDocumentMutation({
      variables: { id: doc.id },
      onCompleted() {
        pageStore.refetchOtherDocs?.();
        delModal.onClose();
      },
      ...onError(),
    });

    useEffect(() => {
      if (editModal.isOpen) store.fillOtherDocumentForm(doc);
    }, [editModal.isOpen]);

    return (
      <FormOtherDocumentCtx.Provider value={store}>
        <Menu>
          <MenuButton as={DataTableActionButton} />
          <MenuList>
            {can("otherDocument_update") && (
              <MenuItem {...editModal.getButtonProps()}>
                <Trans>Edit</Trans>
              </MenuItem>
            )}
            {can("otherDocument_delete") && (
              <MenuItem {...delModal.getButtonProps()}>
                <Trans>Delete</Trans>
              </MenuItem>
            )}
          </MenuList>
        </Menu>
        <ModalConfirm
          {...delModal.getDisclosureProps()}
          {...delModal}
          onConfirm={del}
        />
        <ModalOtherDocumentForm
          {...editModal.getDisclosureProps()}
          {...editModal}
          title={t`Edit order`}
          mode={FormMode.EDIT}
          primaryActionContent={t`Save changes`}
          loading={updateReq.loading}
          defaultContractorName={doc.contractors?.[0]?.legalName}
          onSubmit={(vars) => {
            update({ variables: { input: { ...vars, id: doc.id } } });
          }}
        />
      </FormOtherDocumentCtx.Provider>
    );
  }),
);
